const AddNewCaseViewerEnum = {
    SentToAnotherDepartment: 5,
}
export default AddNewCaseViewerEnum